import React from "react";
import CrewWorkingHourMaster from "./CrewWorkingHours/CrewWorkingHourMaster";
import CrewUtilizationMaster from "./CrewUtilization/CrewUtilizationMaster";
import CrewPDDMaster from "./CrewPDD/CrewPDDMaster";
import CrewOutsideMaster from "./CrewOutSideRest/CrewOutsideMaster";
import CrewHQMaster from "./CrewHQRest/CrewHQMaster";
import CrewAvgMaster from "./CrewAvgRest/CrewAvgMaster";
const CMSBody = ({ activePage }) => {
  return (
    <div className="ms-2 me-2">
      {activePage === "Crew Working Hours" && <CrewWorkingHourMaster />}
      {activePage === "Crew Utilization" && <CrewUtilizationMaster />}
      {activePage === "Crew PDD" && <CrewPDDMaster />}
      {activePage === "HQ Crew Rest At Outstation" && <CrewOutsideMaster />}
      {activePage === "Outstation Crew Rest At HQ" && <CrewHQMaster />}
      {activePage === "Average Rest" && <CrewAvgMaster />}
    </div>
  );
};
export default CMSBody;
